export enum SubscriptionScheme {
  pixAutomatico = 'PIX_AUTOMATICO',
  card = 'CARD',
}

export default SubscriptionScheme
